import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import MainContainer from "components/layout/MainContainer";
import { LayoutGroup } from "framer-motion";

import { routes } from "./utils/constants";

let router = createBrowserRouter(routes);

function App() {
  return (
    <LayoutGroup>
      <MainContainer>
        <ToastContainer />
        <RouterProvider router={router} fallbackElement={<p>Loading...</p>} />
      </MainContainer>
    </LayoutGroup>
  );
}

export default App;
